import "bootstrap/dist/css/bootstrap.css";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./NewCustomerForm.css";
import { DealerTypeOptions, NewCustomerSelect } from "./NewCustomerSelect";
import CreateCustomer from "./CreateCustomer";
import PageTitle from "../common/PageTitle";
import CustomContainer from "../common/CustomContainer";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { SilentRequest } from "@azure/msal-browser";

export interface NewCustomerInfo {
  companyName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  licenses: number;
  mobileLicenses: number;
  dealerType: string;
  firstName: string;
  lastName: string;
  contactPhone: string;
  contactEmail: string;
  salesRep: string;
  notes: string;
}

export type Option = {
  option: React.ReactNode;
  value: string;
};

export default function NewCustomerForm()
{
  const [error, setError] = useState("");
  const { register, handleSubmit, errors } = useForm<NewCustomerInfo>();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const title = "Create New Company";
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [dealerType, setDealerType] = useState<Option>(DealerTypeOptions[0]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
    if (!isChecked)
      setDealerType(DealerTypeOptions[9])
    else
      setDealerType(DealerTypeOptions[0])
  };

  const handleDealerTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDealerType(DealerTypeOptions[event.target.selectedIndex])
  }
  
  const onSubmit = handleSubmit(async (request) => 
  {
    if (isAuthenticated) 
    {
      const account = instance.getAllAccounts()[0];
  
      const silentRequest: SilentRequest = {
        scopes: ["api://a22e7296-106f-4a00-af8d-f86edb386a1b/api_access"],
        account: account,};

      const token = await instance.acquireTokenSilent(silentRequest);

      console.log(request);

      CreateCustomer(request, token.accessToken)
        .then(async (res) => {
          if (res.ok) {
            console.log(res);     
          }        
        })
        .catch((err) => {
          let message;
          if (err instanceof Error) message = err.message;
          else message = String(error);
          setError(message);
        })
        .finally(()=>{
          navigate("/");
        });
    }
  });  

  return (
      <CustomContainer>
      {isAuthenticated ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span style={{ margin: "1%" }}>
            <PageTitle title={title}></PageTitle>
          </span>

          <form onSubmit={onSubmit}  style={{width: "45%",}}>
            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    className="form-control"
                    id="CompanyName"
                    data-testid="CompanyName"
                    type="text"
                    ref={register({ required: true, minLength: 2 })}
                    name="companyName"
                    placeholder="Company Name"
                  />
                  <label htmlFor="CompanyName">Company Name</label>

                  {errors.companyName && errors.companyName.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.companyName && errors.companyName.type === "minLength" && (
                    <span className="errors">
                      This field required a min length of 2
                    </span>
                  )}
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="Address"
                    className="form-control"
                    id="Address"
                    type="text"
                    ref={register({ required: true, minLength: 2 })}
                    name="address"
                    placeholder="Address"
                  />
                  <label htmlFor="Address">Address</label>
                  {errors.address && errors.address.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.address && errors.address.type === "minLength" && (
                    <span className="errors">
                      This field required a min length of 2
                    </span>
                  )}
                </div>
              </div>


            </div>


            <div className="row">
              <div className="col-4">
                <div className="form-floating mb-2">
                  <input
                    data-testid="City"
                    className="form-control"
                    id="City"
                    type="text"
                    ref={register({ required: true, minLength: 2 })}
                    name="city"
                    placeholder="City"
                  />
                  <label htmlFor="City">City</label>
                  {errors.city && errors.city.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.city && errors.city.type === "minLength" && (
                    <span className="errors">
                      This field required a min length of 2
                    </span>
                  )}
                </div>
              </div>

              <div className="col-4">
                <div className="form-floating mb-2">
                  <input
                    data-testid="State"
                    className="form-control"
                    id="State"
                    type="text"
                    ref={register({ required: true, maxLength:2 })}
                    name="state"
                    min="0"
                    maxLength={2}
                    placeholder="State"
                  />
                  <label htmlFor="State">State</label>
                  {errors.state && errors.state.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                        {errors.state && errors.state.type === "maxLength" && (
                    <span className="errors">
                      This field allows a maximum of 3 characters
                    </span>
                  )}
                </div>
              </div>

              <div className="col-4">
                <div className="form-floating mb-2">
                  <input
                    data-testid="Zip"
                    className="form-control"
                    id="Zip"
                    type="text"
                    ref={register({ required: true, minLength:5 })}
                    name="zip"
                    placeholder="Zip"
                    min="0"
                    minLength={5}
                    maxLength={10}
                  />
                  <label htmlFor="Zip">Zip</label>
                  {errors.zip && errors.zip.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                    {errors.zip && errors.zip.type === "minLength" && (
                    <span className="errors">Between 5 and 10 characters</span>
                  )}
                        {errors.zip && errors.zip.type === "maxLength" && (
                    <span className="errors">Between 5 and 10 characters</span>
                  )}
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="Licenses"
                    className="form-control"
                    id="Licenses"
                    type="number"
                    ref={register({ required: true })}
                    name="licenses"
                    min="3"
                    placeholder="Licenses"
                  />
                  <label htmlFor="Licenses">Licenses</label>
                  {errors.licenses && errors.licenses.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                </div>
              </div>

              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="MobileLicenses"
                    className="form-control"
                    id="MobileLicenses"
                    type="number"
                    ref={register({ required: true })}
                    name="mobileLicenses"
                    placeholder="Mobile Licenses"
                    min="0"
                  />
                  <label htmlFor="MobileLicenses">Mobile Licenses</label>
                  {errors.mobileLicenses &&
                    errors.mobileLicenses.type === "required" && (
                      <span className="errors">This field is required</span>
                    )}
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="FirstName"
                    className="form-control"
                    id="firstName"
                    ref={register({ required: true, minLength: 2 })}
                    name="firstName"
                    type="text"
                    placeholder="First Name"
                  />
                  <label htmlFor="firstName">First Name</label>
                  {errors.firstName && errors.firstName.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.firstName && errors.firstName.type === "minLength" && (
                    <span className="errors">
                      This field required a min length of 2
                    </span>
                  )}
                </div>
              </div>

              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="LastName"
                    className="form-control"
                    id="lastName"
                    ref={register({ required: true, minLength: 2 })}
                    name="lastName"
                    type="text"
                    placeholder="Last Name"
                  />
                  <label htmlFor="lastName">Last Name</label>
                  {errors.lastName && errors.lastName.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.lastName && errors.lastName.type === "minLength" && (
                    <span className="errors">
                      This field required a min length of 2
                    </span>
                  )}
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="ContactPhone"
                    type="text"
                    className="form-control"
                    id="contactPhone"
                    pattern="^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$"
                    placeholder="Phone"
                    ref={register({
                      required: true,
                      minLength: 10,
                    })}
                    name="contactPhone"
                  />
                  <label htmlFor="contactPhone">Phone</label>
                  {errors.contactPhone &&
                    errors.contactPhone.type === "required" && (
                      <span className="errors">This field is required</span>
                    )}
                  {errors.contactPhone &&
                    errors.contactPhone.type === "minLength" && (
                      <span className="errors">
                        This field required a min length of 10
                      </span>
                    )}
                </div>
              </div>

              <div className="col">
                <div className="form-floating mb-2">
                  <input
                    data-testid="ContactEmail"
                    className="form-control"
                    id="floatingInput"
                    type="email"
                    placeholder="Email"
                    ref={register({ required: true, minLength: 2 })}
                    name="contactEmail"
                  />
                  <label htmlFor="email">Email</label>
                  {errors.contactEmail &&
                    errors.contactEmail.type === "required" && (
                      <span className="errors">This field is required</span>
                    )}
                  {errors.contactEmail &&
                    errors.contactEmail.type === "minLength" && (
                      <span className="errors">
                        This field required a min length of 2
                      </span>
                    )}
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-4">
                <div style={{paddingTop: '15px'}}>
                    <input type='checkbox' checked={isChecked} onChange={handleCheckboxChange} className="form-check-input"/>
                    <label style={{paddingLeft: '7px'}} className="form-check-label">Is internal/testing?</label>
                </div>
              </div>

              <div className="col-4">
                <div className="form-floating mb-2">
                  <NewCustomerSelect
                    options={DealerTypeOptions}
                    className="form-control"
                    id="dealerType"
                    ref={register({ required: true })}
                    name="dealerType"
                    value={dealerType.value}
                    onChange={handleDealerTypeChange}
                  />
                  <label htmlFor="dealerType">Dealer Type</label>
                  {errors.dealerType && errors.dealerType.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                </div>
              </div>

              <div className="col-4">
                <div className="form-floating mb-2">
                  <input
                    className="form-control"
                    id="salesRep"
                    data-testid="SalesRep"
                    type="text"
                    ref={register({ required: true, maxLength: 3 })}
                    name="salesRep"
                    placeholder="Sales Rep"
                    maxLength={3}
                  />
                  <label htmlFor="salesRep">Sales Rep</label>

                  {errors.salesRep && errors.salesRep.type === "required" && (
                    <span className="errors">This field is required</span>
                  )}
                  {errors.salesRep && errors.salesRep.type === "maxLength" && (
                    <span className="errors">
                      This field allows a maximum of 3 characters
                    </span>
                  )}
                </div>
              </div>      
            </div>


            <div className="row">
              <div className="col">
                <div className="form-floating mb-2">
                  <textarea
                    data-testid="Notes"
                    className="form-control"
                    id="notes"
                    rows={5}
                    ref={register}
                    name="notes"
                    placeholder="Notes"
                  />
                  <label htmlFor="notes">Notes</label>
                </div>     
              </div>         
            </div>

            <div style={{ textAlign: "center" }}>
              <button
                style={{ width: "10rem", fontWeight:700, height:'55px', fontSize:'1.15rem'}}
                type="submit"
                className="btn btn-success"
              >
                Submit
              </button>
            </div>

            <br/><br/>

          </form>
        </div>
        ):(<h5>Login to use the application</h5>)}
      </CustomContainer>
    );
}
